// extracted by mini-css-extract-plugin
export default {"mapContainer":"styles_mapContainer__II5VZ","map":"styles_map__fqya7","legenda":"styles_legenda__2x21B","legendaCor":"styles_legendaCor__acdg-"};